import React from "react";
import { useTheme } from "../Providers/ThemeContext";

const StepIndicator = ({
  currentStep,
  totalSteps,
  onUpdateClick,
  isInvited = false,
}) => {
  const { colors } = useTheme();

  // Étapes visibles après filtrage
  const steps = isInvited
    ? Array.from({ length: totalSteps }, (_, i) => i + 1).filter(
        (step) => step !== 3, // Exclure l'étape 3 si invité
      )
    : Array.from({ length: totalSteps }, (_, i) => i + 1);

  const visibleStepsCount = steps.length; // Total des étapes visibles
  const currentStepIndex = steps.indexOf(currentStep); // Index de l'étape actuelle dans steps

  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-2">
        {steps.map((step, index) => (
          <div
            key={step}
            onClick={() => {
              onUpdateClick(step); // Aller directement à l'étape autorisée
            }}
            className="w-10 h-10 rounded-full flex items-center justify-center cursor-pointer "
            style={{
              backgroundColor:
                index <= currentStepIndex ? colors.primary : colors.background,
              color:
                index <= currentStepIndex ? colors.background : colors.text,
              border: `1px solid ${colors.border}`,
            }}
          >
            {index + 1}
          </div>
        ))}
      </div>
      <div
        className="relative h-2 rounded-full overflow-hidden"
        style={{ backgroundColor: colors.background }}
      >
        <div
          className="absolute w-full h-full rounded-full"
          style={{
            backgroundColor: colors.border,
          }}
        />
        <div
          className="absolute h-full rounded-full z-1 transition-all duration-500"
          style={{
            // Barre d'avancement avec animation fluide
            width: `${((currentStepIndex + 1) / visibleStepsCount) * 100}%`,
            backgroundColor: colors.primary,
          }}
        />
      </div>
    </div>
  );
};

export default StepIndicator;
